import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { MixpanelService } from 'src/app/services/mixpanel/mixpanel.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public error: string;
  // On the way to the WorkOS login page; the Sign in button is only shown when that fails
  public redirecting = false;

  // Back from WorkOS can restore this page as it was left, on its way to WorkOS, without running
  // ngOnInit again. Nothing is under way any more, so the user needs the button.
  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent): void {
    if (event.persisted) {
      this.redirecting = false;
    }
  }

  loginWithWorkOS(): void {
    this.mixpanelService.track('Action: Login with WorkOS');
    this.goToWorkOS(this.authService.startRequestedLogin());
  }

  private goToWorkOS(login: Observable<void>): void {
    this.error = '';
    this.redirecting = true;
    login.subscribe(
      () => {
        // window.location.href has been set by AuthService; nothing more to do.
      },
      (err) => {
        console.error('Failed to obtain WorkOS authorization URL', err);
        this.redirecting = false;
        this.error = 'We were unable to start the login process. Please try again later.';
      }
    );
  }

  constructor(
    private router: Router,
    private authService: AuthService,
    private mixpanelService: MixpanelService
  ) { }

  ngOnInit() {
    // If they're already logged in, send them to the dashboard
    if (this.authService.isLoggedIn()) {
      this.mixpanelService.track('Page: Login (already logged in)');
      this.router.navigate(['dashboard']);
      return;
    }
    this.mixpanelService.track('Page: Login');
    // Go straight to the WorkOS login page, unless that would undo a logout or repeat a
    // login that has just brought the user back here
    if (this.authService.canStartLoginAutomatically()) {
      this.goToWorkOS(this.authService.startAutomaticLogin());
    }
  }
}
